export default {
  lots: []
}
